import React from 'react'
import './One_clothes.scss'

function One_clothes() {
  return (
    <div>One_clothes</div>
  )
}

export default One_clothes